import React from 'react'
import Typical from 'react-typical'
import './Profile.css'

export default function Profile() {
    return (
        <div className="profile-container">
            <div className="profile-parent">
                <div className="profile-details">
                    <div className="colz">
                        <div className="colz-icons">
                            <a href="#">
                                <i className='fa fa-facebook-square'>
                                </i>
                            </a>
                            <a href="#">
                                <i className='fa fa-google-plus -square'>
                                </i>
                            </a>
                            <a href="#">
                                <i className='fa fa-linkedin-square'>
                                </i>
                            </a>
                            <a href="#">
                                <i className='fa fa-twitter-square'>
                                </i>
                            </a>
                        </div>

                    </div>
                    <div className="profile-details-name">
                        <div className="primary-text">
                            {" "}
                            Hello, I'M <span className="highlighted-text">Mumbere Arnold</span>
                        </div>
                        <div className="profile-details-role">
                            <span className="primary-text">
                                {" "}
                                <h1>
                                    {" "}
                                    <Typical
                                        loop={Infinity}
                                        steps={[
                                            "Enthusiastic Tech Guy 💻", 1000,
                                            "Solidity/Ethereum Developer 🔥", 1000,
                                            "Full Stack Android Dev 📱", 1000,
                                            "Full Stack Web Dev 🌍", 1000,
                                            "Flutter Dev 🔥", 1000,
                                        ]}
                                    />
                                </h1>
                                <span className="profile-role-tagline">
                                    Always ready to building your Mobile/Web appplications and Smart Contracts.
                                </span>
                            </span>
                        </div>
                        <div className="profile-options">
                            <button className="btn primary-btn">
                                {" "}
                                Hire Me {" "}
                            </button>
                            <a href="mumbere_resume.pdf" download="mumbere_resume.pdf">
                                <button className="btn highlighted-btn">Download Resume</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="profile-picture">
                    <div className="profile-picture-background">

                    </div>
                </div>
            </div>
        </div>
    )
}